export default "__VITE_ASSET__CVbEecnN__"